import request from 'tools/request'
import { EnumEndpointState, MY_ENDPOINT_CACHE_DURATION_MS, MY_ENDPOINT_TIMEOUT_MS } from 'types/request'
import { UserInfo, UserResponse } from 'types/users'

type EndpointStateType = {
  state: EnumEndpointState
  data: UserInfo | null
  expiresAt: number
}

const myUserEndpoint: EndpointStateType = {
  state: 'IDLE',
  data: null,
  expiresAt: 0,
}

let myUserRequestId = 0
export const invalidateMyUserCache = () => {
  myUserRequestId++
  myUserEndpoint.state = 'IDLE'
  myUserEndpoint.data = null
  myUserEndpoint.expiresAt = 0
}

// TECH DEBT: Refactor this and myRole to avoid code duplication
export const getMyUser = async () => {
  return new Promise<UserInfo>((resolve, reject) => {
    const now = Date.now()
    if (myUserEndpoint.state === 'SUCCESS' && myUserEndpoint.expiresAt > now && myUserEndpoint.data) {
      resolve(myUserEndpoint.data)
      return
    }

    if (myUserEndpoint.state === 'LOADING') {
      let elapsed = 0
      const checkInterval = setInterval(() => {
        if (myUserEndpoint.state === 'SUCCESS' && myUserEndpoint.data) {
          clearInterval(checkInterval)
          resolve(myUserEndpoint.data)
        } else if (myUserEndpoint.state === 'ERROR') {
          clearInterval(checkInterval)
          reject(new Error('Failed to fetch user data'))
        } else {
          elapsed += 100
          if (elapsed >= MY_ENDPOINT_TIMEOUT_MS) {
            clearInterval(checkInterval)
            reject(new Error('Timeout waiting for user data fetch'))
          }
        }
      }, 100)
      return
    }

    const requestId = ++myUserRequestId
    myUserEndpoint.state = 'LOADING'
    getMyUserEndpoint()
      .then((user) => {
        if (requestId !== myUserRequestId) {
          reject(new Error('Stale user data fetch'))
          return
        }
        myUserEndpoint.state = 'SUCCESS'
        myUserEndpoint.data = user
        myUserEndpoint.expiresAt = Date.now() + MY_ENDPOINT_CACHE_DURATION_MS
        resolve(user)
      })
      .catch((error) => {
        if (requestId !== myUserRequestId) {
          reject(new Error('Stale user data fetch'))
          return
        }
        myUserEndpoint.state = 'ERROR'
        reject(error)
      })
  })
}

const getMyUserEndpoint = async () => {
  const data = await request.get<UserResponse>('users/me').then((res) => res.data.user)
  return data
}
